import React from "react"
import OfferDisplayStatusConst from "../../common/variables/OfferDisplayStatusConst";
import {dateTimePrint} from '../../common/methods/CommonUtil'
import { useTranslation } from "react-i18next";

function OfferVenue(props) {
  const { t } = useTranslation();
  
  let datest = new Date(props.startTime);
  let dateot = new Date(props.openTime);

  return (
      <dd className="detail-info__text">
        {props.display_status === OfferDisplayStatusConst.archive ?
          <>
          {dateTimePrint(props.language , datest, 'YYYYMMDDY')}
          {t("offer.start")}
          <br/>
          {props.venue}
          </>
        :
          <>
          {dateTimePrint(props.language , datest, 'YYYYMMDDY')}
          {' ' + t("offer.start")}
          {' [ ' + t("offer.streamStartTime") + dateTimePrint(props.language , dateot, 'HHMM') +  ' ]'}
          <br/>
          {props.venue}
          </>
        } 
      </dd>
  )
}

export default OfferVenue
